import { render } from "./ModuleLabeledInfo.vue?vue&type=template&id=013a466c"
import script from "./ModuleLabeledInfo.vue?vue&type=script&lang=js"
export * from "./ModuleLabeledInfo.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__